import state from './moduleAuditTrailState.js'
import mutations from './moduleAuditTrailMutation.js'
import actions from './moduleAuditTrailActions.js'
import getters from './moduleAuditTrailGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
